// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file bffuser/v1/bidding_intraday_market_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import { BiddingIntradayMarketService } from "./bidding_intraday_market_service_pb";

/**
 * 板 (1 コマ分の注文一覧) を取得。
 *
 * @generated from rpc bffuser.v1.BiddingIntradayMarketService.ListBiddingMarketOrderBook
 */
export const listBiddingMarketOrderBook = BiddingIntradayMarketService.method.listBiddingMarketOrderBook;

/**
 * 連系線容量一覧を取得。
 *
 * @generated from rpc bffuser.v1.BiddingIntradayMarketService.ListBiddingInterconnectionCapacities
 */
export const listBiddingInterconnectionCapacities = BiddingIntradayMarketService.method.listBiddingInterconnectionCapacities;

/**
 * ティッカー (約定履歴) 一覧を取得。
 *
 * @generated from rpc bffuser.v1.BiddingIntradayMarketService.ListBiddingMarketContracts
 */
export const listBiddingMarketContracts = BiddingIntradayMarketService.method.listBiddingMarketContracts;

/**
 * コマ取引状態一覧 (48 コマ分) を取得。
 *
 * @generated from rpc bffuser.v1.BiddingIntradayMarketService.ListBiddingMarketProducts
 */
export const listBiddingMarketProducts = BiddingIntradayMarketService.method.listBiddingMarketProducts;

/**
 * コマ別 約定サマリ一覧 (48 コマ分) を取得。
 *
 * @generated from rpc bffuser.v1.BiddingIntradayMarketService.ListBiddingMarketContractSummaries
 */
export const listBiddingMarketContractSummaries = BiddingIntradayMarketService.method.listBiddingMarketContractSummaries;
